/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { S3RestoreTarget } from '../models/S3RestoreTarget';

export class EksNamespaceRestoreDestination {
  's3Bucket'?: S3RestoreTarget;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "s3Bucket",
      "baseName": "s3Bucket",
      "type": "S3RestoreTarget",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EksNamespaceRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

